import React, { useEffect, useState } from 'react';
import { getAdminProducts, getAdminCategories } from '../../services/adminApi';
import {
  HiOutlineShoppingBag,
  HiOutlineCollection,
  HiOutlineClipboardList,
} from 'react-icons/hi';

interface StatCard {
  label: string;
  value: number;
  icon: React.ReactNode;
  color: string;
}

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<StatCard[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [prodRes, catRes] = await Promise.all([
          getAdminProducts(),
          getAdminCategories(),
        ]);
        const products = Array.isArray(prodRes.data) ? prodRes.data : prodRes.data.results || [];
        const categories = Array.isArray(catRes.data) ? catRes.data : catRes.data.results || [];
        setStats([
          {
            label: 'Products',
            value: products.length,
            icon: <HiOutlineShoppingBag size={28} />,
            color: '#c9a96e',
          },
          {
            label: 'Categories',
            value: categories.length,
            icon: <HiOutlineCollection size={28} />,
            color: '#4a90d9',
          },
          {
            label: 'Featured',
            value: products.filter((p: any) => p.featured).length,
            icon: <HiOutlineClipboardList size={28} />,
            color: '#50c878',
          },
        ]);
      } catch {
        // ignore
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <h1 className="admin-page-title">Dashboard</h1>
      {loading ? (
        <div className="admin-spinner" />
      ) : (
        <div className="admin-stats-grid">
          {stats.map((s) => (
            <div className="admin-stat-card" key={s.label}>
              <div className="admin-stat-icon" style={{ backgroundColor: s.color + '20', color: s.color }}>
                {s.icon}
              </div>
              <div className="admin-stat-info">
                <span className="admin-stat-value">{s.value}</span>
                <span className="admin-stat-label">{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
